/* Vannrok theme — mobile nav */
(function () {
  const toggle = document.querySelector(".nav-toggle");
  const mobile = document.querySelector(".nav-mobile");
  if (!toggle || !mobile) return;

  toggle.addEventListener("click", function () {
    const open = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!open));
    mobile.classList.toggle("is-open", !open);
  });

  mobile.querySelectorAll("a").forEach(function (link) {
    link.addEventListener("click", function () {
      toggle.setAttribute("aria-expanded", "false");
      mobile.classList.remove("is-open");
    });
  });
})();
